/**
 * Port of `commonComponents/checkInLoadingPopup.jsx`.
 *
 * The original declared two style objects (`af_regionStyle`, `checkinLoading`) and the
 * `CheckinLoad` gif import, then used none of them — the render is two bare divs whose
 * appearance comes entirely from App.css. Dead code is dropped rather than carried,
 * because `noUnusedLocals` rejects it and it has no runtime effect. The rendered DOM is
 * unchanged, including the single space inside each div.
 */
export function CheckInLoadingPopup({
  initialLoading,
}: {
  initialLoading?: boolean;
}): JSX.Element {
  return (
    <>
      <div>
        {initialLoading ? (
          <div className="initial-loading"> </div>
        ) : (
          <div className="blocking-glass-pane"> </div>
        )}
      </div>
    </>
  );
}
